import { render } from "./DataScienceMlCompanyPage.vue?vue&type=template&id=c59dfdc0"
import script from "./DataScienceMlCompanyPage.vue?vue&type=script&lang=js"
export * from "./DataScienceMlCompanyPage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\77460\\Desktop\\homepage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__